import { Alert, AlertColor } from '@mui/material';
import { CustomContentProps, SnackbarContent, useSnackbar } from 'notistack';
import { forwardRef, useCallback } from 'react';

interface SnackbarProps extends CustomContentProps {}

const Snackbar = forwardRef<HTMLDivElement, SnackbarProps>(
  ({ id, ...props }, ref) => {
    const { closeSnackbar } = useSnackbar();

    const handleDismiss = useCallback(() => {
      closeSnackbar(id);
    }, [id, closeSnackbar]);

    const mapVariantToSeverity = (variant: any): AlertColor | undefined => {
      if (variant === 'default') return 'info';
      return variant;
    };

    return (
      <SnackbarContent ref={ref}>
        <Alert
          onClose={handleDismiss}
          severity={mapVariantToSeverity(props.variant)}
          sx={{ width: '100%', whiteSpace: 'pre-line' }}
        >
          {props.message}
        </Alert>
      </SnackbarContent>
    );
  }
);

export default Snackbar;
